import React, { Component } from "react";
import PropTypes from "prop-types";
import { View, TouchableHighlight, StyleSheet, Platform } from "react-native";
import Text from "../TextFont";
import { IconButton } from "../Buttons";
import { Badge } from "react-native-material-bottom-navigation";
import { getDir } from "../../util";

class RBSheetInnerSettingItem extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    onPress: PropTypes.func,
    showBadge: PropTypes.bool,
    badgeNumber: PropTypes.number,
    highlighted: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <TouchableHighlight
        underlayColor="#FFF"
        onPress={() => {
          this.props.onPress && this.props.onPress();
        }}
        style={{ backgroundColor: this.props.highlighted ? "#eee" : "#fff" }}
      >
        <View style={{ flexDirection: "row" }}>
          <View
            style={[styles.bottomSheetItem, { flex: 1, direction: getDir() }]}
          >
            <Text
              style={{
                fontSize: 20,
                paddingTop: 8,
                paddingBottom: 8,
                fontWeight: this.props.highlighted ? "bold" : "normal",
                color: this.props.highlighted
                  ? ArTheme.COLORS.GRAY_DARK
                  : "#666666",
              }}
            >
              {this.props.text}
            </Text>
            <IconButton
              style={{
                width: 50,
                borderRadius: 25,
                paddingTop: 8,
              }}
              onPress={() => {
                this.props.onPress && this.props.onPress();
              }}
              icon={{
                code: this.props.icon || "\uf013",
                style: {
                  fontFamily: "FontAwesomeProLight",
                  fontSize: 26,
                  color: this.props.highlighted
                    ? ArTheme.COLORS.GRAY_DARK
                    : "#333333",
                },
              }}
            />
          </View>
          {this.props.showBadge == true && (
            <Badge
              style={[
                {
                  //width: 12,
                  minWidth: 12,
                  height: 12,
                  position: "absolute",
                  top: 10,
                },
                Platform.OS === "web" ? { start: 55 } : { end: 55 },
              ]}
            >
              {this.props.badgeNumber > 0 ? this.props.badgeNumber : ""}
            </Badge>
          )}
        </View>
      </TouchableHighlight>
    );
  }
}

const styles = StyleSheet.create({
  bottomSheetItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomColor: "#eee",
    borderBottomWidth: 1,
    marginStart: 10,
    marginEnd: 10,
    height: 50,
  },
});
export default RBSheetInnerSettingItem;
